import ApiClient from "../../infrastructure/api/ApiClient";
import OffersDao from "../../infrastructure/dao/OffersDao";
import OfferMediumsDao from "../../infrastructure/dao/OfferMediumsDao";
import MediumAvailabilitiesDao from "../../infrastructure/dao/MediumAvailabilitiesDao";
import { SessionData } from "../../model/Session";
import Storage from "../Storage";
import FilesDao from "../../infrastructure/dao/FilesDao";

export default class DaoLocator {
    private instances: { [name: string]: object } = {};
    private readonly apiClient: ApiClient;
    private readonly storage: Storage<{ session?: SessionData }>;

    constructor(apiClient: ApiClient, storage: Storage<{ session?: SessionData }>) {
        this.apiClient = apiClient;
        this.storage = storage;
    }

    public mediumAvailabilities = () => this.get('mediumAvailabilities', () => new MediumAvailabilitiesDao(this.apiClient));
    public offerMediums = () => this.get('offerMediums', () => new OfferMediumsDao(this.apiClient));
    public offers = () => this.get('offers', () => new OffersDao(this.apiClient));
    public files = () => this.get('files', () => new FilesDao(this.apiClient));

    private readonly get = <T extends object>(name: string, factory: () => T): T => {
        if (!this.instances[name]) {
            this.instances[name] = factory();
        }
        return this.instances[name] as T;
    };
}
